import { render, staticRenderFns } from "./section1.vue?vue&type=template&id=78ad5812&scoped=true"
import script from "./section1.vue?vue&type=script&lang=js"
export * from "./section1.vue?vue&type=script&lang=js"
import style0 from "./section1.vue?vue&type=style&index=0&id=78ad5812&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad5812",
  null
  
)

export default component.exports